/**
 * pcn-forms-ios-fix.js — Fix global iOS/Safari para Shopify Forms (shadow DOM).
 *
 * En Safari tactil, el click que se sintetiza tras un tap se dispara contra
 * el HOST <shopify-forms-embed> en vez del control interno del shadow DOM:
 * el campo nunca recibe mousedown/focus y el teclado no abre. Reproducido en
 * WebKit (tap -> click en el host, foco null; click de mouse -> funciona).
 * Afecta a todo embed de Forms: landings, paginas de producto, popups.
 *
 * Si un click llega DISPARADO en el propio host (composedPath()[0] === host,
 * o sea que no vino retargeteado desde adentro), buscamos el control real
 * bajo el dedo con elementFromPoint del shadow root y lo activamos. En
 * navegadores sanos el click ya nace en el control interno y esto no actua.
 *
 * Idempotente: si ya se instalo (p. ej. via pcn-landing.js en las landings),
 * no se engancha dos veces — importante para no duplicar click() en botones.
 */
(function () {
  'use strict';

  if (window.__pcnFormsIosFix) return;
  window.__pcnFormsIosFix = true;

  document.addEventListener('click', function (e) {
    var host = e.target;
    if (!host || !host.tagName || host.tagName !== 'SHOPIFY-FORMS-EMBED') return;

    // Click legitimo originado dentro del shadow DOM: llega retargeteado al
    // host pero composedPath()[0] es el control interno. No intervenir
    // (tambien evita loops cuando abajo re-disparamos click()).
    var origen = e.composedPath ? e.composedPath()[0] : host;
    if (origen !== host) return;

    var sr = host.shadowRoot;
    if (!sr || !sr.elementFromPoint) return;

    var el = sr.elementFromPoint(e.clientX, e.clientY);
    if (!el || !el.closest) return;

    var control = el.closest('input, textarea, select, button, label');
    if (!control) return;

    var esToggle = control.tagName === 'INPUT' && (control.type === 'checkbox' || control.type === 'radio');
    if (control.tagName === 'BUTTON' || esToggle) {
      control.click();
    } else if (control.tagName === 'LABEL') {
      var interno = control.control || control.querySelector('input, textarea, select');
      if (interno) interno.focus();
    } else if (sr.activeElement !== control) {
      control.focus();
    }
  }, true);
})();
